import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['outputContainer', 'input', 'actions', 'fileName', 'saveButton', 'errorMessage']

  // QRCode Monkey logo limit: 2MB max file size
  MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB in bytes

  selectImage() {
    this.inputTarget.click();
  }

  displayImagePreview(event) {
    event.preventDefault();

    const input = this.inputTarget;
    const outputContainer = this.outputContainerTarget;

    // Clear previous error
    this.hideError();

    if (!input.files || !input.files[0]) {
      return;
    }

    const file = input.files[0];

    // Validate file size
    if (file.size > this.MAX_FILE_SIZE) {
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      this.showError(`Logo must be less than 2MB. Current size: ${sizeInMB}MB`);
      input.value = ''; // Clear the input
      return;
    }

    outputContainer.innerHTML = '';
    this.fileNameTarget.textContent = file.name;
    const reader = new FileReader();

    reader.onload = (e) => {
      const imageSrc = e.target.result;

      outputContainer.className = 'flex gap-2 items-center';

      outputContainer.parentElement.classList.remove('hidden');
      this.actionsTarget.classList.remove('hidden');
      outputContainer.removeAttribute('data-action');
      outputContainer.classList.remove('cursor-pointer');

      const img = document.createElement('img');
      img.src = imageSrc;
      img.className = 'max-w-full max-h-full object-contain';

      outputContainer.appendChild(img);

      // Show save button when new logo is selected
      if (this.hasSaveButtonTarget) {
        this.saveButtonTarget.classList.remove('hidden');
      }
    };

    reader.readAsDataURL(file);
  }

  showError(message) {
    // Remove existing error if any
    this.hideError();

    // Create error message element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'text-red-400 text-small mt-2';
    errorDiv.textContent = message;
    errorDiv.setAttribute('data-logo-target', 'errorMessage');

    // Insert error after the file input container
    const inputContainer = this.inputTarget.closest('.flex');
    if (inputContainer && inputContainer.parentElement) {
      inputContainer.parentElement.insertBefore(errorDiv, inputContainer.nextSibling);
    }
  }

  hideError() {
    const existingError = this.element.querySelector('[data-logo-target="errorMessage"]');
    if (existingError) {
      existingError.remove();
    }
  }
}
